const apiURL="https://finbackendapi.gurgaonit.com/api";

// const apiURL="http://localhost:5050/api";

const invoiceURL="https://finval-cron.gurgaonit.com/storage/app/public/invoices/";


export {apiURL, invoiceURL}